import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "antd";
import Heading from "./Heading";
import InfoBlock from "./InfoBlock";
import AllocationTable from "./AllocationTable";
import { BoxDetailWrapper, InfoTitle } from "../style";
import formatter from "./../../../../../../../utils/formatter";

export const typeContentMap = {
  weightedAllocations: "By weighted percentage",
  byDollars: "By percentage or dollar amount",
  byPercentage: "By specified percentage",
  perDollarAmount: "By percentage or dollar amount",
};

export const allSharesAllPoolsTypeContent = "Entire Balance of all pools";
export const allSharesTypeContent = "Entire Balance of specified pool(s)";

export const getAllocationPreference = (
  allocationType,
  allSharesAllPoolsType,
  allSharesType
) => {
  if (allSharesAllPoolsType) {
    return allSharesAllPoolsTypeContent;
  } else if (allSharesType) {
    return allSharesTypeContent;
  }
  return typeContentMap[allocationType];
};

export const renderOneTimeSummary = ({
  allSharesAllPoolsType = false,
  allSharesType = false,
  paymentType,
  startDate,
  amountString,
}) => {
  let paymentTitle = "Total Payment";
  if (allSharesAllPoolsType || allSharesType) {
    paymentTitle = "Approximate Grant Amount*";
  }
  return (
    <>
      <BoxDetailWrapper border>
        <InfoBlock title="Payment" value={paymentType} />
      </BoxDetailWrapper>
      {startDate && (
        <BoxDetailWrapper border>
          <InfoBlock title="Scheduled Issue Date" value={startDate} />
        </BoxDetailWrapper>
      )}
      <BoxDetailWrapper>
        <InfoBlock title={paymentTitle} value={amountString} />
        {(allSharesAllPoolsType || allSharesType) && (
          <InfoTitle>
            *Underlying investment values change each day, so this amount is
            subject to change.
          </InfoTitle>
        )}
      </BoxDetailWrapper>
    </>
  );
};

export const renderAgreementPayment = (grantAgreementAmount) => {
  return (
    <Row>
      <InfoBlock
        title="Total grant agreement amount"
        value={formatter({
          value: grantAgreementAmount,
          fieldSuffix: "Dollars",
        })}
      />
    </Row>
  );
};

export const renderRecurringPayment = (paymentType, frequency) => {
  return (
    <Row type="flex">
      <Col span={12}>
        <InfoBlock title="Payment" value={paymentType} />
      </Col>
      <Col span={11} offset={1}>
        <InfoBlock title="Frequency" value={frequency} />
      </Col>
    </Row>
  );
};

export const renderRecurringSummary = ({
  grantAgreement,
  grantAgreementAmount,
  paymentType,
  frequency,
  startDate,
  endDate,
  amountString,
}) => {
  return (
    <>
      <BoxDetailWrapper border>
        {grantAgreement
          ? renderAgreementPayment(grantAgreementAmount)
          : renderRecurringPayment(paymentType, frequency)}
      </BoxDetailWrapper>
      <BoxDetailWrapper border>
        {/* As per bug OW-363, Given condition to render Recommended amount & allocation card */}
        {grantAgreement ? (
          <Row type="flex">
            <Col span={12}>
              <InfoBlock title="Start Date" value={startDate} />
            </Col>
            <Col span={11} offset={1}>
              <InfoBlock title="End Date" value={endDate} />
            </Col>
          </Row>
        ) : (
          <Row>
            <Col span={12}>
              <InfoBlock title="End Date" value={endDate} />
            </Col>
          </Row>
        )}
      </BoxDetailWrapper>
      <BoxDetailWrapper>
        <InfoBlock title="Total number of payments" value={amountString} />
      </BoxDetailWrapper>
    </>
  );
};


/**
 * Components layout is complicated because of the design requirements
 *
 */
export default function Step2Summary({
  title,
  edit,
  handleEdit,
  recurring = false,
  paymentType,
  startDate,
  endDate,
  frequency,
  amountString,
  allocationType,
  allocations,
  grantAgreement = false,
  grantAgreementAmount,
  allSharesAllPools = false,
  allShares = false,
}) {
  return (
    <>
      <Heading
        id="btnRecomamountallocation"
        title={title}
        edit={edit}
        handleEdit={handleEdit}
      />
      <Row type="flex">
        <Col lg={8} span={24}>
          {recurring
            ? renderRecurringSummary({
                grantAgreement,
                grantAgreementAmount,
                paymentType,
                frequency,
                startDate,
                endDate,
                amountString,
              })
            : renderOneTimeSummary({ paymentType, startDate, amountString })}
        </Col>
        <Col lg={{ span: 14, offset: 2 }} span={24}>
          <BoxDetailWrapper border>
            <InfoBlock
              border
              title="Allocation Preference"
              value={getAllocationPreference(
                allocationType,
                allSharesAllPools,
                allShares
              )}
            />
          </BoxDetailWrapper>
          <AllocationTable
            allocations={allocations}
            allShares={allShares}
            allSharesAllPools={allSharesAllPools}
          />
        </Col>
      </Row>
    </>
  );
}

Step2Summary.propTypes = {
  title: PropTypes.string,
  edit: PropTypes.bool,
  handleEdit: PropTypes.func,
  recurring: PropTypes.bool,
  paymentType: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  frequency: PropTypes.string,
  amountString: PropTypes.string,
  allocationType: PropTypes.string,
  allocations: PropTypes.arrayOf(
    PropTypes.shape({
      allShare: PropTypes.bool,
      grantAmount: PropTypes.string,
      grantPercentage: PropTypes.number,
      id: PropTypes.number,
      name: PropTypes.string,
      units: PropTypes.number,
    })
  ),
  grantAgreement: PropTypes.bool,
  grantAgreementAmount: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  allSharesAllPools: PropTypes.bool,
  allShares: PropTypes.bool,
};
